"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerGroupNode = exports.PlayerGroupCreate = exports.PlayerGroupSummary = void 0;
const zod_1 = require("zod");
const resource_schema_js_1 = require("./resource.schema.js");
const enums_js_1 = require("./enums.js");
exports.PlayerGroupSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    parent_id: zod_1.z.string().uuid().nullable(),
    name_i18n: resource_schema_js_1.NameI18n,
    // Screen-inventory (SP2) — OPTIONAL during the rollout (server always sends
    // them; the tree endpoint resolves ancestry). Phase B consumes them.
    kind: zod_1.z.enum(enums_js_1.GroupKinds).optional(),
    ancestry: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string().uuid(), name: zod_1.z.string() })).optional(),
});
exports.PlayerGroupCreate = zod_1.z.object({
    parent_id: zod_1.z.string().uuid().nullable(),
    name_i18n: resource_schema_js_1.NameI18n,
    kind: zod_1.z.enum(enums_js_1.GroupKinds).optional(),
});
exports.PlayerGroupNode = exports.PlayerGroupSummary.extend({
    children: zod_1.z.lazy(() => zod_1.z.array(exports.PlayerGroupNode)),
});
//# sourceMappingURL=group.schema.js.map